if (!customElements.get('scrolling-bar')) {
  customElements.define(
    'scrolling-bar',
    class AnnouncementBar extends HTMLElement {
      constructor() {
        super();
        this.slider = this.querySelector(`#ScrollingBar-${this.sectionId}`);
        if (!this.slider) return;
        this.initSlider();
      }

      get sectionId() {
        return this.dataset.sectionId;
      }

      get scrollSpeed() {
        return this.dataset.speed;
      }

      initSlider() {
        const options = {
          spaceBetween: 40,
          speed: Number(this.scrollSpeed) * 10,
          slidesPerView: 'auto',
          slidesPerMove: 1,
          freeMode: true,
          freeModeMomentum: false,
          allowTouchMove: false,
          pagination: false,
          navigation: false,
          resistance: false,
          loop: true,
          autoplay: {
            delay: 0,
          },
          breakpoints: {
            750: {
              spaceBetween: 80,
            },
          },
        };

        const slider = new Swiper(this.slider, options);
      }
    }
  );
}
